import style from './style.module.scss';

const TableHeadCell = ({ children, ...rest }) => (
  <th {...rest} scope="col" className={style.table_head_cell}>
    {children}
  </th>
);

export default TableHeadCell;
